// Auth state rides in the Google/Apple OAuth `state` parameter as
// {csrfToken}.{base64(JSON.stringify({provider, type, redirectUri, linkId, ...}))}
export function decodeOAuthState(state: string): Record<string, string> | null {
	try {
		const dotIndex = state.indexOf(".");
		if (dotIndex === -1) return null;
		return JSON.parse(atob(state.substring(dotIndex + 1)));
	} catch {
		return null;
	}
}

// The signed "Sign in with Select" request: Phoenix's /oauth/authorize sends
// the browser here with ?flow=oauth&oauth_request=..., and a Google/Apple
// login started from that page carries it back inside `state`.
export function readOauthRequest(search: string): string | null {
	const query = new URLSearchParams(search);
	if (query.get("flow") === "oauth") return query.get("oauth_request");
	const state = query.get("state");
	return (state && decodeOAuthState(state)?.oauthRequest) || null;
}
